import { atom } from 'recoil';
import { IAuth } from '../../commons/types/usuatios';

export const authAtom = atom({
  key: 'auth',
  default: localStorage.getItem('usuario') 
    ? JSON.parse(localStorage.getItem('usuario')!) as IAuth
    : null,
});
